import { appState } from "../../utils/store";
import { getInteractiveNodesAtPoint } from "./InteractionObserver.utils";
import * as PIXI from "pixi.js";
import { addFilter, removeFilter } from "../../utils/filters";
import type { CoreComponent } from "../coreComponents/coreComponents.types";
import {
  getViewport,
  isViewportInitialized
} from "../../pixi-components/layers/viewport/viewport.layer";

/**
 * This observer finds all the interactive nodes at the current cursor position and sets the viewport cursor accordingly.
 */

// Stores the last interactive node that was hovered over
let lastInteractiveNode: CoreComponent | undefined;

const cursorChangeObserver = () => {
  if (!isViewportInitialized()) return;
  const viewport = getViewport();
  const { x, y } = appState.localCursorPosition;
  const interactiveNodes = getInteractiveNodesAtPoint({ x, y });
  const node = interactiveNodes[0]; // Topmost interactive node

  // If the current node is different from the last interactive node:
  if (node !== lastInteractiveNode) {
    // If there is a last interactive node
    if (lastInteractiveNode) {
      // Remove hover filter from lastInteractiveNode
      removeFilter(lastInteractiveNode.pixiComponent);

      // Reset cursor to default
      viewport.cursor = "default";
    }

    // Update lastInteractiveNode to current node
    lastInteractiveNode = node;

    // If there is a current node:
    if (node) {
      viewport.cursor = node.props.style?.cursor || "auto";

      if (node.props.style.hover?.backgroundColor) {
        // Apply hover filter if hover styles are defined
        addFilter(node.pixiComponent, node.props.style.hover.backgroundColor);
      }
    }
  }
  // else do nothing (cursor is still over the same node)};
};

const initCursorChangeObserver = () => {
  PIXI.Ticker.shared.add(cursorChangeObserver);
};

const removeCursorChangeObserver = () => {
  PIXI.Ticker.shared.remove(cursorChangeObserver);
};
export { initCursorChangeObserver, removeCursorChangeObserver };
